export default {
  inserted(el) {
    const input = el.querySelector("input") || el;

    input.addEventListener("blur", (e) => {
      let value = e.target.value;
      if (value) {
        e.target.value = parseFloat(value).toFixed(2);
        input.dispatchEvent(new Event("input"));
      }
    });
  },
};
